import { faCheck, faCalendar } from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Link from "next/link";

export default function ProgramComparison() {
  return (
    <section className="relative mx-auto py-8 px-8 bigscreen-responsive md:px-0 md:mb-8 md:py-24">
      <div className="flex justify-center py-2">
        <h1 className="uppercase text-orange text-md font-bold">Programas Técnicos</h1>
      </div>
      <div className="flex flex-col justify-center text-center gap-2">
        <h2 className="font-bold text-3xl">Compará programas</h2> 
        <p className="font-thin text-sm md:text-md">Seleccioná el programa que te lleva más lejos</p>
      </div>
      <div className="flex flex-col justify-center items-center gap-8 py-8 xl:flex-row xl:items-start xl:justify-between xl:py-16">
        <div className="rounded-[40px] border-2 border-green max-w-md px-10 py-4 flex-1">
          <h3 className="font-bold text-green text-3xl pt-6">Técnico Básico</h3>
          <p className="text-sm">en Gastronomía</p>
          <p className="flex py-4">Aprenderás a:</p>
          <div className="text-gray-500 text-sm md:text-lg">
            <ul>
              <li className="mb-2"><FontAwesomeIcon icon={faCheck} className="font-light text-green mr-2" /> Conocimiento y manipulación de alimentos</li>
              <li className="mb-2"><FontAwesomeIcon icon={faCheck} className="font-light text-green mr-2" /> Trabajo en equipo</li>
              <li className="mb-2"><FontAwesomeIcon icon={faCheck} className="font-light text-green mr-2" /> Bases técnicas culinarias</li>
            </ul>
          </div>
          <div className="rounded-xl bg-green/15 py-6 mt-4 w-max-md px-4">
            <p className="font-bold text-center text-green text-2xl mr-2 md:text-4xl">300 <span className="font-normal text-lg text-gray-500">horas prácticas</span></p>
          </div>
          <div className="flex text-center relative gap-6 py-8 md:justify-around md:text-left">
            <p className="text-green font-bold uppercase text-sm md:text-md"><FontAwesomeIcon icon={faCalendar} className="font-light text-green mr-2 " /> Duración</p>
            <div className="absolute top-7 inline-block h-12 min-h-[1em] w-px self-stretch bg-green opacity-85 ml-[90px] md:mr-32 md:h-7"/>
            <p className="font-bold uppercase text-sm md:text-md">3 cuatrimestres</p>
          </div>
          <div className="flex flex-col justify-center items-center gap-8 py-6 md:justify-center md:items-center md:text-left md:gap-6 md:py-1">
            <Link href='https://wa.me/50662236864' target='_blank' className="flex items-center text-center font-bold text-xs text-white rounded-full py-3 px-5 shadow-sm bg-gradient-to-r from-green to-green-dark/85 hover:shadow-lg md:text-nowrap md:py-3 md:px-8 md:text-sm">
              Contactá para matricular 
            </Link>
            <Link href="/programas/basico" className="flex items-center font-bold text-xs rounded-full py-3 px-8 shadow-sm bg-white border-2 border-green hover:bg-green/15 hover:shadow-lg md:text-nowrap md:py-3 md:px-11 md:text-sm">
              Ver más información
            </Link>
          </div>
        </div>
        <div className="rounded-[40px] border-2 border-orange max-w-md px-10 py-4 flex-1">
          <h3 className="font-bold text-orange text-3xl pt-6">Técnico Medio</h3>
          <p className="text-sm">en Gastronomía</p>
          <p className="flex py-4">Aprenderás a:</p>
          <div className="text-gray-500 text-sm md:text-lg">
            <ul>
              <li className="mb-2"><FontAwesomeIcon icon={faCheck} className="font-light text-green mr-2" /> Todo lo del básico</li>
              <li className="mb-2"><FontAwesomeIcon icon={faCheck} className="font-light text-green mr-2" /> Preparación de recetas y menús</li>
              <li className="mb-2"><FontAwesomeIcon icon={faCheck} className="font-light text-green mr-2" /> Costeo de recetas y presupuesto</li>
              <li className="mb-2"><FontAwesomeIcon icon={faCheck} className="font-light text-green mr-2" /> Manejo de equipo en cocina</li>
              <li className="mb-2"><FontAwesomeIcon icon={faCheck} className="font-light text-green mr-2" /> Resolución de conflictos de manera asertiva</li>
              
            </ul>
          </div>
          <div className="rounded-xl bg-[#FDA3501A] py-6 mt-4 w-max-md px-4">
            <p className="font-bold text-center text-orange text-2xl mr-2 md:text-4xl">600 <span className="font-normal text-lg text-gray-500">horas prácticas</span></p>
          </div>
          <div className="flex text-center relative gap-6 py-8 md:justify-around md:text-left">
            <p className="text-orange font-bold uppercase text-sm md:text-md"><FontAwesomeIcon icon={faCalendar} className="font-light text-orange mr-2" /> Duración</p>
            <div className="absolute top-7 inline-block h-12 min-h-[1em] w-px self-stretch bg-orange opacity-85 ml-[90px] md:mr-32 md:h-7"/>
            <p className="font-bold uppercase text-sm md:text-md">4 cuatrimestres</p>
          </div>
          <div className="flex flex-col justify-center items-center gap-8 py-6 md:justify-center md:items-center md:text-left md:gap-6 md:py-1">
            <Link href='https://wa.me/50662236864' target='_blank' className="flex items-center font-bold text-xs text-white rounded-full py-3 px-5 shadow-sm bg-gradient-to-r from-[#FBA919] to-[#F68729] hover:shadow-lg md:text-nowrap md:py-3 md:px-8 md:text-sm">
              Contactá para matricular 
            </Link>
            <Link href="/programas/medio" className="flex items-center font-bold text-xs rounded-full py-3 px-8 shadow-sm bg-white border-2 border-orange hover:bg-orange/15 hover:shadow-lg md:text-nowrap md:py-3 md:px-11 md:text-sm">
              Ver más información
            </Link>
          </div>
        </div>
        <div className="rounded-[40px] border-2 border-red max-w-md px-8 py-4 flex-1">
          <h3 className="font-bold text-red text-3xl pt-6">Técnico Profesional</h3>
          <p className="w-60 text-sm">en Artes Culinarias y Emprendimiento con énfasis en Gastronomía</p>
          <p className="flex py-4">Aprenderás a:</p>
          <div className="text-gray-500 text-sm md:text-lg">
            <ul>
              <li className="mb-2"><FontAwesomeIcon icon={faCheck} className="font-light text-green mr-2" /> Todo lo del medio</li>
              <li className="mb-2"><FontAwesomeIcon icon={faCheck} className="font-light text-green mr-2" /> Administrar un establecimiento gastronómico</li>
              <li className="mb-2"><FontAwesomeIcon icon={faCheck} className="font-light text-green mr-2" /> Innovar y crear productos gastronómicos</li>
              <li className="mb-2"><FontAwesomeIcon icon={faCheck} className="font-light text-green mr-2" /> Dominar las técnicas culinarias profesionales</li>
              <li className="mb-2"><FontAwesomeIcon icon={faCheck} className="font-light text-green mr-2" /> Emprendedurismo</li>
            </ul>
          </div>
          <div className="rounded-xl bg-[#E87F851A]/10 py-6 px-4 mt-4 w-max-md">
            <p className="font-bold text-center text-red text-2xl mr-2 md:text-4xl">900 <span className="font-normal text-lg text-gray-500">horas prácticas</span></p>
          </div>
          <div className="flex text-center relative gap-6 py-8 md:justify-around md:text-left">
            <p className="text-red font-bold uppercase text-sm md:text-md"><FontAwesomeIcon icon={faCalendar} className="font-light text-red mr-2" /> Duración</p>
            <div className="absolute top-7 inline-block h-12 min-h-[1em] w-px self-stretch bg-red opacity-85 ml-[105px] md:mr-32 md:h-7"/>
            <p className="font-bold uppercase text-sm md:text-md">7 cuatrimestres</p>
          </div>
          <div className="flex flex-col justify-center items-center gap-8 py-6 md:justify-center md:items-center md:text-left md:gap-6 md:py-1">
            <Link href='https://wa.me/50662236864' target='_blank' className="flex items-center font-bold text-xs text-white rounded-full py-3 px-8 shadow-sm bg-gradient-to-r from-red to-[#CE2341] hover:shadow-lg md:text-nowrap md:text-sm">
              Contactá para matricular
            </Link>
            <Link href="/programas/profesional" className="flex items-center font-bold text-xs rounded-full py-3 px-10 shadow-sm bg-white border-2 border-red hover:bg-red/15 hover:shadow-lg md:text-nowrap md:py-3 md:px-12 md:text-sm">
              Ver más información
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}